export enum PhoneNumberVerificationSteps {
  PHONE_CONNECT,
  PHONE_VERIFY,
  PHONE_COUNTRY_SELECT,
  NONE,
}
